import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Modal from "../../../component/templates/Modal";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import AskApi from "../../../api/ask.api";
import PretendardText from "../../../component/atoms/text/pretendardText";

function AskModal({ data, setModalOpen, listHandler }) {
  const [askData, setAskData] = useState({ ...data, answer: data.answer || "" });
  const [editAskData, setEditAskData] = useState({
    ...data,
    answer: data.answer || "",
  });
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (!editAskData.answer?.trim()) {
      return toast(`필수 요소를 전부 입력해주세요.`);
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        answer: editAskData.answer.trim(),
      };

      await AskApi.updateAnswer(askData.id, data);
      toast(toastMsg.update);
      setSaveModalOpen(false);
      setAskData({ ...askData, answer: editAskData.answer.trim() });
      listHandler();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <ModalWrapper>
        <ModalBox>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <TableTitle style={{ marginBottom: "0px" }}>{"문의 상세"}</TableTitle>
            <img
              style={{
                cursor: "pointer",
              }}
              src="/assets/admin/icons/ico_popup_close.svg"
              alt=""
              onClick={() => setModalOpen(false)}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              minHeight: "223px",
              overflowY: "auto",
            }}
          >
            <DetailPageForm>
              <DetailFormTitle>{"답변상태"}</DetailFormTitle>
              <DetailFormText>
                <AnswerText isAnswer={askData.answer}>{isNull(askData.answer) ? "답변대기" : "답변완료"}</AnswerText>
              </DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"작성일"}</DetailFormTitle>
              <DetailFormText>{moment(askData.createdAt).format("YYYY/MM/DD")}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"아이디"}</DetailFormTitle>
              <DetailFormText>{askData.member?.account}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"이름"}</DetailFormTitle>
              <DetailFormText>{askData.member?.name}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"닉네임"}</DetailFormTitle>
              <DetailFormText>{askData.member?.nickname}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"제목"}</DetailFormTitle>
              <DetailFormText>{askData.title}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm style={{ alignItems: "flex-start" }}>
              <DetailFormTitle>{"내용"}</DetailFormTitle>
              <DetailFormText style={{ width: "100%", maxHeight: "200px", overflowY: "auto" }}>{`${askData.content}`}</DetailFormText>
            </DetailPageForm>
            <div
              style={{
                width: "100%",
                height: 5,
                backgroundColor: "#F8F8F8",
                margin: "10px 0",
              }}
            />
            <DetailPageForm style={{ alignItems: "flex-start" }}>
              <DetailFormTitle>{"답변"}</DetailFormTitle>
              {!askData.answer && (
                <MainInput
                  style={{
                    width: "730px",
                  }}
                  type={"text"}
                  placeholder={"내용을 입력해 주세요."}
                  value={editAskData.answer}
                  onChange={(e) => setEditAskData({ ...editAskData, answer: e.target.value })}
                />
              )}
              {askData.answer && <DetailFormText style={{ width: "100%", maxHeight: "200px", overflowY: "auto" }}>{askData.answer}</DetailFormText>}
            </DetailPageForm>
            <SaveBtn
              text={askData.answer ? `수정하기` : `답변하기`}
              style={{
                position: "static",
                marginTop: "20px",
                width: "fit-content",
                alignSelf: "flex-end",
              }}
              onClick={
                askData.answer === ""
                  ? saveBtnHandler
                  : () => {
                      setAskData({ ...askData, answer: "" });
                    }
              }
            />
          </div>
        </ModalBox>
      </ModalWrapper>
      {saveModalOpen ? (
        <Modal
          title={modalMsg.update.title}
          text={modalMsg.update.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
}

export default AskModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 30;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 1064px;
  padding: 50px;
  border: 1px solid #d7dbe0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  /* 스크롤바 스타일 */
  &::-webkit-scrollbar {
    width: 17px; /* 스크롤바 너비 */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* 스크롤바 트랙 배경색 */
    border-radius: 10px; /* 스크롤바 트랙 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바 색상 */
    border: 7px solid #fff;
    border-radius: 10px; /* 스크롤바 둥근 모서리 */
  }
`;

const AnswerText = styled(PretendardText)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: ${(props) => (props.isAnswer ? "#000" : "#27BEFF")};
`;
